import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import Achievements from "./Achievements";
import Education from "./Education";
import Experience from "./Experience";
import developer from "../../Assets/developer.jpg";
import { SKILLS, TOOLS } from "../../Constants";

function About() {
  return (
    <Container fluid className="about-section">
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }} className="fade-in">
              <strong className="purple">About Me</strong>
            </h1>
            <div className="fade-in fade-in-delay-2">
              <Aboutcard />
            </div>
          </Col>
          <Col md={5} style={{ paddingBottom: "50px" }} className="about-img fade-in fade-in-delay-3">
            <img src={developer} alt="about" className="image-style" />
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", paddingTop: "30px" }}>
          <Col md={12} className="fade-in">
            <Experience />
          </Col>
        </Row>
        
        <Row style={{ justifyContent: "center", paddingTop: "30px" }}>
          <Col md={12} className="fade-in">
            <Achievements />
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", paddingTop: "30px" }}>
          <Col md={12} className="fade-in">
            <Education />
          </Col>
        </Row>

        <Row className="skill-tools-wrapper fade-in">
          <Col className="skill-wrapper">
            <h1 className="project-heading">
              Professional <strong className="purple">Skillset </strong>
            </h1>
            {SKILLS.map((skill, index) => (
              <Techstack
                name={skill.name}
                initialRating={skill.initialRating}
                key={index}
              />
            ))}
          </Col>
          <Col className="skill-wrapper">
            <h1 className="project-heading">
              <strong className="purple">Tools</strong> I use
            </h1>
            {TOOLS.map((tool, index) => (
              <ul key={index} className="tool-name">
                <li>{tool}</li>
              </ul>
            ))}
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
